import { BroadcastMessage } from '@crealogix-map/core';
import { BrowserModule } from './BrowserModule';
import { ScreenRotation } from './ScreenRotation';

/**
 * Request the device to only allow specific rotations.
 */
export class ConfigureRotationMessage extends BroadcastMessage {
  constructor(public rotation: ScreenRotation) {
    super();
  }

  readonly tag: string = BrowserModule.configureRotationMessage;
}



// WEBPACK FOOTER //
// /Users/zasa/map/map-core-git/~/tslint-loader??ref--0-1!./src/Browser/ConfigureRotationMessage.ts